<template>
  <div
    v-if="sizes.length"
    :class="[
      'select-size',
      { 'select-size-empty': !sizeSelected },
    ]"
  >
    <div
      v-if="label"
      class="select-size-label"
    >
      <div v-text="label" />
      <slot />
    </div>

    <ul class="select-size-sizes">
      <li
        v-for="s in sizes"
        :key="s.id"
        :class="{
          'outofstock': !s.available,
          'active': checkSizeActive(s),
          'pickup': checkPickupStatus(s)
        }"
        v-text="s.size"
        @click="select(s)"
        @mouseover="toggleHint(s)"
        @mouseout="toggleHint()"
      />
    </ul>

    <div
      v-if="visibleHint"
      class="select-size-hint"
    >
      <transition name="fade">
        <span v-show="contentIsValid && contentIsVisible">
          <b>{{ currentSize }}</b> есть в наличии только в {{ availableStores }}
          {{ availableStores | decl('магазин', ['е', 'ах', 'ах']) }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'select-size',

  data() {
    return {
      hoverSize: {},
      isVisible: false
    }
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    sizes: {
      type: Array,
      default: () => ([]),
    },

    activeSku: {
      type: Object,
      default: () => {}
    },

    visibleHint: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    sizeSelected() {
      return !!this.activeSku.id
    },

    currentSize() { // размер товара
      return this.hoverSize?.size || this.activeSku?.size;
    },
    
    availableStores() { // количество магазинов чтобы забрать сегодня
      return this.hoverSize?.pickup?.store?.storesCount
          || this.activeSku?.pickup?.store?.storesCount;
    },

    contentIsValid() {
      return this.currentSize && this.availableStores;
    },

    hoverSizeIsValid() {
      return (!this.hoverSize?.delivery && !this.hoverSize?.pickup?.delayed)
    },

    hoverSizeIsEmpty() {
      return !Object.keys(this.hoverSize).length;
    },

    chosenSizeIsValid() {
      return (!this.activeSku?.delivery && !this.activeSku?.pickup?.delayed)
    },

    contentIsVisible() {
      return (this.hoverSizeIsValid && !this.hoverSizeIsEmpty)
          || (this.chosenSizeIsValid && this.hoverSizeIsEmpty);
    }
  },

  methods: {
    select(item) {
      if (item.id === this.activeSku.id) return;
      this.$emit('change', item);
    },

    toggleHint(size = {}) {
      this.hoverSize = size;
    },

    checkPickupStatus(size) {
      return !size.delivery && !size.pickup?.delayed;
    },

    checkSizeActive(size) {
      return size.available && size.size === this.activeSku.size
    }
  }
}
</script>

<style lang="scss">
.select-size {
  &-label {
    display: flex;
    justify-content: space-between;
  }

  &-sizes {
    list-style: none;
    display: flex;
    flex-wrap: wrap;

    & > li {
      position: relative;
      text-align: center;
      min-width: 32px;
      padding: 6px 8px;
      margin: 8px 8px 0 0;
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      color: $gray;
      background-color: $white;
      box-shadow: inset 0 0 0 1px $gray_lu;
      border-radius: 4px;
      cursor: pointer;

      &.pickup {
        background-color: $gray_bgr;
        color: $gray;
      }

      &.active {
        color: $black;
        box-shadow: inset 0 0 0 2px $black;
      }

      &.outofstock {
        // гипотенуза от 300 === 424
        background: linear-gradient(45deg, $gray_bgr 211px, $gray_lu 212px, $gray_bgr 213px);
        background-size: 300px 300px;
        background-position: center;
        pointer-events: none;
        color: $gray_lu;
      }
    }
  }

  &-hint {
    margin-top: 12px;
    height: 16px;
    color: $black;
    font-size: 12px;
    line-height: 16px;
  }
}

@include breakpoint("desktop") {
  .select-size {
    &-sizes {
      & > li {
        min-width: 40px;
        padding: 10px 8px;

        &:hover {
          color: $black;
        }
      }
    }

    &-hint {
      margin-top: 16px;
      font-size: 14px;
    }
  }
}
</style>
